import React from "react";
import logo from "../assets/sme-logo.png";

const InitialModalRedemption = ({ data, handleShowLogin }) => {
    return (
        <>
            <div className="p-3 flex w-full justify-between">
                <img src={logo} alt="logo" className="w-[100px] h-auto object-contain" />

                <button
                    className="w-max bg-primary-yellow hover:bg-yellow-500 text-white text-base font-bold py-2 px-6 rounded"
                    onClick={handleShowLogin}
                >
                    Staff Login
                </button>
            </div>

            <div className="flex w-full justify-center  mt-8 h-max  ">
                <div className=" p-6 rounded-lg w-full space-y-5 max-w-md ">
                    <h2 className="text-2xl text-primary-color font-bold mb-4 text-center">
                        Redemption Details
                    </h2>
                    <p><strong>Name:</strong> {data.firstName} {data.lastName}</p>
                    <p><strong>Reference:</strong> {data.reference}</p>
                    <div className="mt-4">
                        <p className="font-bold text-primary-color mb-2">Items to Redeem:</p>
                        <ul className="list-disc space-y-5 list-inside text-gray-700">
                            {data.items.map((item, index) => (
                                <li key={index}>
                                    {item.quantity} of {item.product} {item.size}
                                </li>
                            ))}
                        </ul>
                    </div>
                    <p className="text-lg">
                        {data.collected ? (
                            <span className="ml-2 inline-block text-green-600 bg-green-400/50 py-2 px-3 rounded-lg font-bold">
                                Collected
                            </span>
                        ) : (
                            <span className="ml-2 inline-block text-red-600 bg-red-500/20 py-2 px-3 rounded-lg font-bold">
                                Not Collected
                            </span>
                        )}
                    </p>
                </div>
            </div>
        </>
    );
};

export default InitialModalRedemption;
